import { Link } from "react-router-dom";
import { Instagram, Youtube, Twitter, Linkedin } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="mt-32 border-t border-white/10 relative z-10">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-20 grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-5">
          <div className="flex items-center gap-4">
            <img
              src="/logo-wolfkeeper-icon.png"
              alt="Wolfkeeper crest"
              className="h-14 w-auto"
            />
            <div>
              <div className="font-serif-display text-xl tracking-tight">Wolfkeeper University</div>
              <div className="overline text-[10px] mt-1">The Harvard of Canine Education</div>
            </div>
          </div>
          <p className="mt-6 max-w-md text-[color:var(--wk-bone-dim)] leading-relaxed">
            Educating the world's most capable dogs, handlers, and trainers since 2002.
            Chicago · Denver · Lisbon · Nairobi · Singapore.
          </p>
          <div className="mt-6 flex gap-4">
            {[Instagram, Youtube, Twitter, Linkedin].map((Icon, i) => (
              <a
                key={i}
                href="#"
                className="w-10 h-10 rounded-full hairline flex items-center justify-center hover:border-[color:var(--wk-gold)] hover:text-[color:var(--wk-gold)] transition-all"
                aria-label="social"
              >
                <Icon size={16} />
              </a>
            ))}
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="overline mb-4">Academy</div>
          <ul className="space-y-3 text-sm text-[color:var(--wk-bone-dim)]">
            <li><Link to="/programs" className="hover:text-[color:var(--wk-gold)]">Programs</Link></li>
            <li><Link to="/university" className="hover:text-[color:var(--wk-gold)]">Online University</Link></li>
            <li><Link to="/assistant" className="hover:text-[color:var(--wk-gold)]">TONIA · AI Mentor</Link></li>
            <li><Link to="/events" className="hover:text-[color:var(--wk-gold)]">Events</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-2">
          <div className="overline mb-4">Institute</div>
          <ul className="space-y-3 text-sm text-[color:var(--wk-bone-dim)]">
            <li><Link to="/about" className="hover:text-[color:var(--wk-gold)]">About</Link></li>
            <li><Link to="/media" className="hover:text-[color:var(--wk-gold)]">Media</Link></li>
            <li><Link to="/careers" className="hover:text-[color:var(--wk-gold)]">Careers</Link></li>
            <li><Link to="/investors" className="hover:text-[color:var(--wk-gold)]">Investors</Link></li>
          </ul>
        </div>
        <div className="lg:col-span-3">
          <div className="overline mb-4">Community</div>
          <ul className="space-y-3 text-sm text-[color:var(--wk-bone-dim)]">
            <li><Link to="/membership" className="hover:text-[color:var(--wk-gold)]">Wolfkeeper Plus Membership</Link></li>
            <li><Link to="/livestream" className="hover:text-[color:var(--wk-gold)]">Founder's Livestream</Link></li>
            <li><Link to="/founder-qa" className="hover:text-[color:var(--wk-gold)]">Ask the Founder</Link></li>
            <li><Link to="/wall" className="hover:text-[color:var(--wk-gold)]">The Founder's Wall</Link></li>
            <li><Link to="/alumni" className="hover:text-[color:var(--wk-gold)]">Alumni Directory</Link></li>
            <li><Link to="/foundation" className="hover:text-[color:var(--wk-gold)]">Golden Wolf Foundation</Link></li>
            <li><Link to="/foundation/dogs" className="hover:text-[color:var(--wk-gold)]">Sponsor a Dog</Link></li>
            <li><Link to="/shop" className="hover:text-[color:var(--wk-gold)]">The Store</Link></li>
            <li><Link to="/bookstore" className="hover:text-[color:var(--wk-gold)]">Bookstore</Link></li>
            <li><Link to="/contact" className="hover:text-[color:var(--wk-gold)]">Contact</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[color:var(--wk-muted)]">
          <div>© {new Date().getFullYear()} Wolfkeeper University. All rights reserved.</div>
          <div className="flex gap-6">
            <a href="#" className="hover:text-[color:var(--wk-gold)]">Terms</a>
            <a href="#" className="hover:text-[color:var(--wk-gold)]">Privacy</a>
            <a href="#" className="hover:text-[color:var(--wk-gold)]">Accessibility</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
